{
  "commonHeader": {
    "upgradeToPro": "Upgraden",
    "learnMore": "Meer informatie",
    "AIProductivitySuite": {
      "title": "AI-productiviteitssuite",
      "desc": "Zet inspirerende discussies om in indrukwekkende resultaten."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Het account van je organisatie beheren met AI",
        "description": "Krijg intelligente antwoorden op je accountvragen en hulp bij het navigeren door instellingen.",
        "terms": "Door de bètafuncties van Zoom te gebruiken, ga je akkoord met {0}",
        "termsText": "de voorwaarden van het Zoom-bètaprogramma"
      },
      "diveDeeper": "Dieper duiken",
      "shareFeedback": "Deel feedback in {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Stel een vraag over het account van uw organisatie",
      "heroInvite": "Hoe nodig ik een nieuwe gebruiker uit voor mijn account?",
      "heroGroups": "Hoe wijs ik gebruikers toe aan groepen?",
      "heroRoles": "Hoe beheer ik rollen en machtigingen?"
    },
    "backMainAccount": "Terug naar het hoofdaccount",
    "discoverProducts": "Producten ontdekken",
    "pricing": "Prijzen",
    "more": "Meer",
    "sidebarExpanded": "uitgevouwen",
    "sidebarCollapsed": "samengevouwen",
    "search": "Zoeken",
    "users": "Gebruikers",
    "settings": "Accountinstellingen",
    "navigation": "Navigatie",
    "clear": "Wissen",
    "searchPlaceholderAll": "Zoeken naar gebruikers, accountinstellingen of navigatie",
    "searchPlaceholderUsers": "Zoeken naar gebruikers of navigatie",
    "searchPlaceholderSettings": "Zoeken naar accountinstellingen of navigatie",
    "searchPlaceholderNav": "Zoeken in navigatie",
    "searchGuide": "Typ trefwoorden om te zoeken",
    "installOnDesktop": "Op desktop installeren",
    "downloadCenter": "Downloadcentrum",
    "getInTouch": "Neem contact op",
    "featuredProduct": "uitgelicht product",
    "logo": {
      "adminCenter": "Beheercentrum",
      "subAccount": "Subaccount beheren",
      "externalAccount": "Gedelegeerd account beheren"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Meer informatie",
      "gotIt": "Begrepen"
    },
    "coachMark": {
      "dvsTipsTitle": "Divisies zijn nu beschikbaar",
      "dvsTipsContent": "Divisies worden gebruikt om meerdere exemplaren van bepaalde Zoom-producten binnen je account te maken."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Meer informatie",
      "gotIt": "Begrepen"
    },
    "coachMark": {
      "extAccountTipsTitle": "Externe accounts beheren",
      "extAccountTipsContent": "Moet je een ander account beheren? Stuur gewoon een verzoek: zodra ze goedkeuren, kun je aan de slag!"
    }
  },
  "feedback": {
    "dialogTitle": "Feedback geven",
    "itemLableForProductArea": "Productgebied",
    "itemLableForSatisfied": "Hoe tevreden bent u over uw ervaring?",
    "dissatisfied": "Zeer ontevreden",
    "satisfied": "Zeer tevreden",
    "itemLableForFeedback": "Feedback",
    "placeholder": "Bedankt voor uw ideeën, reacties en suggesties.",
    "btnCancel": "Annuleren",
    "btnSubmit": "Indienen",
    "supportTips": "Ga bij technische vragen naar",
    "btnSupport": "Ondersteuning.",
    "messages": {
      "success": "Bedankt voor uw feedback!",
      "productFailed": "Productgebied is vereist.",
      "scoreFailed": "Tevredenheidsscore is vereist."
    },
    "products": {
      "General": "Algemeen",
      "AI": "AI",
      "Apps": "Apps",
      "Calendar": "Agenda",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Vergaderingen",
      "Notes": "Notities",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Planner",
      "Tasks": "Taken",
      "TeamChat": "Teamchat",
      "WebinarsAndEvents": "Webinars en evenementen",
      "Whiteboard": "Whiteboard",
      "WorkflowAutomations": "Workflowautomatisering",
      "WorkspaceReservation": "Werkplekreservering",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Deze disclaimer is gegenereerd door uw accountbeheerder.",
    "cancel": "Annuleren",
    "agree": "Accepteren"
  },
  "shared": {
    "sideMenu": {
      "personal": "Persoonlijk",
      "admin": "Beheerder",
      "menu": "Menu",
      "pinned": "Vastgemaakt",
      "pin": "Vastmaken",
      "unpin": "Losmaken",
      "moveItem": "Item verplaatsen",
      "myAccount": "Mijn account",
      "upgradeToPro": "Upgraden naar Pro",
      "grabbedKeyboard": "{0} vastgepakt. Gebruik de pijltoetsen omhoog en omlaag om te verplaatsen, spatie of Enter om neer te zetten.",
      "dropped": "{0} neergezet.",
      "releasedUnchanged": "{0} losgelaten, positie ongewijzigd.",
      "movedToPosition": "{0} verplaatst naar positie {1} van {2}.",
      "movedUp": "{0} omhoog verplaatst, positie {1} van {2}.",
      "movedDown": "{0} omlaag verplaatst, positie {1} van {2}.",
      "movedUpNew": "{0} omhoog verplaatst, nieuwe positie {1} van {2}",
      "movedDownNew": "{0} omlaag verplaatst, nieuwe positie {1} van {2}",
      "cannotMoveFurther": "{0} kan niet verder worden verplaatst.",
      "grabbedMouse": "{0} vastgepakt. Beweeg de muis om te herpositioneren, klik om neer te zetten, druk op Escape om te annuleren."
    },
    "item": "Item",
    "gotIt": "Begrepen",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Het telefoonnummer is toegevoegd. Je kunt het nu gebruiken om je aan te melden en je account te herstellen.",
    "mfa_to_signin_phone_success": "{phone} is nu het nummer voor aanmelding voor {email}.",
    "login_passkey_bound_success": "Je passkey is gemaakt"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "De volgende geavanceerde beheerfuncties zijn alleen van toepassing op gebruikers met een licentie en samenwerkingsgebruikers",
      "licensed_basic": "De volgende geavanceerde beheerfuncties zijn alleen van toepassing op gebruikers met een licentie en basisgebruikers",
      "licensed": "De volgende geavanceerde beheerfuncties zijn alleen van toepassing op gebruikers met een licentie"
    },
    "support": "- Ondersteund in accountinstellingen en instellingen voor gebruikersgroepen",
    "archive_product": {
      "title": "Vergaderingen en webinars archiveren",
      "detail": "- Vergaderingen worden gearchiveerd wanneer gebruikers in uw account deelnemen. Als u deze instelling wilt gebruiken, installeert u een <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">archiverings-app</a> uit de Zoom App Marketplace."
    },
    "restrict": {
      "title": "Gebruikers mogen de geselecteerde functies niet gebruiken wanneer ze deelnemen aan een vergadering",
      "detail": "- Geselecteerde functies kunnen niet gebruikt worden, zelfs niet als de host van de vergadering deze inschakelt voor vergaderingen."
    },
    "meeting_integration": {
      "title": "DLP-integratie (Data Loss Prevention) inschakelen voor Chatten tijdens vergadering",
      "detail": "- Als dit is ingeschakeld, dan is DLP van toepassing op zowel openbare als privéchatberichten die een deelnemer verzendt. De berichten worden onmiddellijk verwijderd als deelnemers aan een vergadering (intern/extern) chatten en een bericht niet voldoet aan het nalevingsbeleid van de organisatie van de host."
    },
    "chat_tool": {
      "title": "Tool voor chatetiquette",
      "detail": "- Identificeer gedefinieerde trefwoorden en tekstpatronen in gedeelde inhoud en voorkom dat gebruikers spamberichten delen"
    },
    "information_barriers": {
      "title": "Informatiebarrières",
      "detail": "- Informatiebarrières regelen de communicatie tussen bepaalde gebruikers voor nalevingsdoeleinden. Er kunnen beperkingen worden ingesteld voor vergaderingen en chats tussen gebruikers in twee groepen en voor gebruikers die bepaalde functies gebruiken (bv. chatten tijdens vergadering, scherm delen en bestandsoverdracht). Deze beperkingen voorkomen dat er vertrouwelijke informatie wordt uitgewisseld tussen ongeautoriseerde gebruikers."
    },
    "dashboard": {
      "title": "Dashboard",
      "detail": "- In het dashboard Vergaderingen > Eerdere vergaderingen, zijn de gegevens van sommige gebruikers alleen zichtbaar voor de afgelopen 3 maanden"
    },
    "reports": {
      "title": "Rapporten",
      "detail": "- Sommige gebruikersrapporten geven alleen de gegevens van de afgelopen 3 maanden van sommige gebruikers weer: het vrijwaringsrapport, het rapport deelnemerslogboek, het rapport activiteitenlogboek van beheerders, en het rapport aanmelden/afmelden"
    },
    "close": "Sluiten"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Je {planName} wordt geannuleerd op {cancelDate}. Voor die datum kun je je webinarlicenties opnieuw activeren. Van {supportStartDate} - {supportEndDate} kun je contact opnemen met de klantenondersteuning om gegevens van bestaande webinars te krijgen. Na {dataLossDate} verlies je alle gegevens van webinars.",
            "nonAdmin": "Je {planName} wordt geannuleerd op {cancelDate}. Tot die datum kun je contact opnemen met je accountbeheerder om je webinarlicenties te reactiveren. Van {supportStartDate} - {supportEndDate} kun je contact opnemen met de klantenondersteuning om gegevens van bestaande webinars te krijgen. Na {dataLossDate} verlies je alle gegevens van de webinars van je account."
          },
          "admin": "Je {planName} wordt geannuleerd op {cancelDate}. Tegen die datum kun je je webinarlicenties opnieuw activeren. Van {supportStartDate} tot {supportEndDate} kun je contact opnemen met de klantenondersteuning om {supportContent} van bestaande webinars op te vragen. Na {dataLossDate} verlies je alle gegevens van de webinars van je account.",
          "nonAdmin": "Je {planName} wordt geannuleerd op {cancelDate}. Tot die datum kun je contact opnemen met je accountbeheerder om je webinarlicenties opnieuw te activeren. Van {supportStartDate} tot {supportEndDate} kun je contact opnemen met de klantenondersteuning om {supportContent} van bestaande webinars te verkrijgen. Na {dataLossDate} verlies je alle gegevens van de webinars van je account."
        },
        "expired": {
          "admin": "Je {planName} is geannuleerd. Van {supportStartDate} tot {supportEndDate} kun je contact opnemen met de klantenondersteuning om {supportContent} van bestaande webinars te verkrijgen, of Zoom Webinars opnieuw aanschaffen om de toegang tot gegevens te herstellen. Na {dataLossDate} verlies je alle gegevens van de webinars van je account.",
          "nonAdmin": "Je {planName} is geannuleerd. Van {supportStartDate} - {supportEndDate} kun je contact opnemen met de klantenondersteuning om de {supportContent} van bestaande webinars op te vragen, of contact opnemen met de accountbeheerder om opnieuw Zoom Webinars te kopen en zo de toegang tot de gegevens te herstellen. Na {dataLossDate} verlies je alle gegevens van de webinars van je account."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Je {planName} wordt op {pausedDate} gepauzeerd voor {pauseDuration}. Tijdens de pauzeperiode kun je alleen de bestaande webinars en hun bijbehorende assets bekijken. Je kunt je pauze op elk gewenst moment opheffen en je abonnement op je webinarlicenties hervatten.",
            "nonAdmin": "Je {planName} wordt op {pausedDate} gepauzeerd voor {pauseDuration}. Tijdens de pauzeperiode kun je alleen de bestaande webinars en de bijbehorende assets bekijken. Je kunt op elk moment contact opnemen met je accountbeheerder om je pauze te verwijderen en het abonnement op je webinarlicenties te hervatten."
          },
          "admin": "Je {planName} wordt op {pausedDate} gepauzeerd voor {pauseDuration}. Tijdens de pauzeperiode kun je alleen {supportContent} bekijken. Je kunt je pauze op elk gewenst moment opheffen en het abonnement op je webinarlicenties hervatten.",
          "nonAdmin": "Je {planName} wordt op {pausedDate} gepauzeerd voor {pauseDuration}. Tijdens de pauzeperiode kun je alleen {supportContent} bekijken. Je kunt op elk moment contact opnemen met je accountbeheerder om je pauze te verwijderen en het abonnement op je webinarlicenties te hervatten."
        },
        "active": {
          "webinars": {
            "admin": "Je {planName} is gepauzeerd voor {pauseDuration} vanaf {pausedDate}. Tijdens de pauze kun je alleen de bestaande webinars bekijken. Je kunt je webinarlicenties op elk gewenst moment hervatten.",
            "nonAdmin": "Je {planName} is gepauzeerd voor {pauseDuration} vanaf {pausedDate}. Tijdens de pauze kun je alleen de bestaande webinars bekijken. Neem gerust contact op met je accountbeheerder om het abonnement op je webinarlicenties op elk gewenst moment te hervatten."
          },
          "admin": "Je {planName} is gepauzeerd voor {pauseDuration}. Tijdens de pauze kun je alleen {supportContent} van bestaande webinars bekijken. Je kunt je webinarlicenties op elk gewenst moment hervatten.",
          "nonAdmin": "Je {planName} is gepauzeerd voor {pauseDuration}. Tijdens de pauze kun je alleen {supportContent} van bestaande webinars bekijken. Neem gerust contact op met je accountbeheerder om het abonnement op je webinarlicenties op elk gewenst moment te hervatten."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Je {planName}-licentie wordt op {pausedDate} voor {pauseDuration} gepauzeerd. Wijs een actieve licentie toe aan deze gebruiker voordat de pauze ingaat om webinars te blijven hosten. Je kunt de pauze ook opheffen om deze licentie te blijven gebruiken.",
            "nonAdmin": "Je {planName}-licentie wordt op {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauzeperiode kun je alleen de bestaande webinars en de bijbehorende assets bekijken. Om webinars te blijven hosten, neem je contact op met je accountbeheerder om een actieve licentie aan je account toe te wijzen voordat de pauze ingaat."
          },
          "active": {
            "admin": "Je {planName}-licentie is vanaf {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauze kun je alleen de bestaande webinars bekijken. Je kunt gerust het abonnement op de licentie hervatten of een actieve licentie toewijzen aan je account om door te gaan met het hosten van webinars.",
            "nonAdmin": "Je {planName}-licentie is vanaf {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauze kun je alleen de bestaande webinars bekijken. Neem contact op met je accountbeheerder om een actieve licentie aan je account toe te wijzen als je tijdens de pauze webinars wilt hosten."
          }
        },
        "cancel": {
          "active": {
            "admin": "Je {planName}-licentie wordt geannuleerd op {cancelDate}. Om webinars te blijven hosten, reactiveer je je webinarlicentie of wijs je een actieve licentie toe voordat de annulering ingaat. Als je geen actie onderneemt, heb je van {supportStartDate} - {supportEndDate} een respijtperiode om contact op te nemen met de klantenondersteuning om je bestaande webinargegevens op te vragen. Na {dataLossDate} worden alle webinargegevens die aan je account zijn gekoppeld, definitief verwijderd.",
            "nonAdmin": "Je {planName}-licentie wordt geannuleerd op {cancelDate}. Om webinars te blijven hosten, neem je contact op met je accountbeheerder om je webinarlicentie te reactiveren of een actieve licentie toe te wijzen voordat de annulering ingaat. Als je geen actie onderneemt, heb je van {supportStartDate} - {supportEndDate} een respijtperiode om contact op te nemen met de klantenondersteuning om je bestaande webinargegevens op te vragen. Na {dataLossDate} worden alle webinargegevens die aan je account zijn gekoppeld, definitief verwijderd."
          },
          "expired": {
            "admin": "Je {planName}-licentie is geannuleerd. Wijs een actieve licentie toe aan deze gebruiker om door te gaan met het hosten van webinars. Je kunt tussen {supportStartDate} en {supportEndDate} contact opnemen met de klantenondersteuning om bestaande webinargegevens op te halen.",
            "nonAdmin": "Je {planName}-licentie is geannuleerd. Om webinars te blijven hosten, neem je contact op met je accountbeheerder om een actieve licentie aan je profiel toe te wijzen. Neem tussen {supportStartDate} en {supportEndDate} contact op met de klantenondersteuning om bestaande webinargegevens op te halen."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Je {planName}-licentie wordt op {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauzeperiode kun je alleen de {supportContent} van eerdere webinars bekijken. Wijs een actieve licentie toe aan deze gebruiker voordat de pauze ingaat om toegang te blijven houden tot de assets van webinars. Je kunt de pauze ook opheffen om deze licentie te blijven gebruiken.",
              "nonAdmin": "Je {planName}-licentie wordt op {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauzeperiode kun je alleen {supportContent} bekijken. Om toegang te blijven houden tot de assets van webinars, neem je contact op met je accountbeheerder om een actieve licentie aan je profiel toe te wijzen."
            },
            "active": {
              "admin": "Je {planName} is vanaf {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauze kun je alleen de {supportContent} van bestaande webinars bekijken. Wijs een actieve licentie toe aan je account om toegang te blijven houden tot assets van webinars. Je kunt dit licentieabonnement ook op elk gewenst moment hervatten.",
              "nonAdmin": "Je {planName} is vanaf {pausedDate} voor {pauseDuration} gepauzeerd. Tijdens de pauze kun je alleen de {supportContent} van bestaande webinars bekijken. Neem contact op met je accountbeheerder om een actieve licentie aan je account toe te wijzen als je tijdens de pauze webinars wilt hosten."
            }
          },
          "cancel": {
            "active": {
              "admin": "Je {planName} wordt geannuleerd op {cancelDate}. Wijs een actieve licentie toe aan je account voordat de annulering van kracht wordt om webinars te blijven hosten. Je kunt deze licentie vóór {cancelDate} opnieuw activeren. Tussen {supportStartDate} en {supportEndDate} kun je contact opnemen met de klantenondersteuning om de {supportContent} van bestaande webinars op te vragen.",
              "nonAdmin": "Je {planName}-licentie wordt geannuleerd op {cancelDate}. Om webinars te blijven hosten, neem je contact op met je accountbeheerder om je webinarlicentie te reactiveren of een actieve licentie toe te wijzen voordat de annulering ingaat. Als je geen actie onderneemt, heb je van {supportStartDate} - {supportEndDate} een respijtperiode om contact op te nemen met de klantenondersteuning om {supportContent} van je bestaande webinars op te vragen. Na {dataLossDate} worden alle webinargegevens die aan je account zijn gekoppeld, definitief verwijderd."
            },
            "expired": {
              "admin": "Je {planName}-licentie is geannuleerd. Wijs een actieve licentie toe aan deze gebruiker om door te gaan met het hosten van webinars. Neem tussen {supportStartDate} en {supportEndDate} contact op met de klantenondersteuning om de {supportContent} van bestaande webinars op te vragen.",
              "nonAdmin": "Je {planName}-licentie is geannuleerd. Om webinars te blijven hosten, neem je contact op met je accountbeheerder om een actieve licentie aan je profiel toe te wijzen. Neem tussen {supportStartDate} en {supportEndDate} contact op met de klantenondersteuning om de {supportContent} van bestaande webinars op te vragen."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "gegevens",
        "recordingsAndTranscripts": "opnames en transcripten",
        "reports": "rapporten",
        "summaries": "samenvattingen",
        "dashboard": "dashboards"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "Opnames en transcripties van eerdere webinars",
          "reports": "rapporten van eerdere webinars",
          "summaries": "Samenvattingen van eerdere webinars",
          "dashboard": "dashboards van eerdere webinars",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Abonnement heractiveren",
    "purchasePlan": "Abonnement kopen",
    "removePause": "Pauze verwijderen",
    "resumeSubscription": "Abonnement hervatten",
    "month": "maand",
    "months": "maanden",
    "assignLicense": "Licentie toewijzen"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Begrepen"
    },
    "coachMark": {
      "tipsTitle": "Adresboek wordt Klantenlijst",
      "tipsContent": "In de release van oktober 2026 hernoemen we Adresboek naar Klantenlijst, zodat de naam beter aansluit bij het doel. Alle bestaande functionaliteit, machtigingen en workflows blijven hetzelfde: je blijft klantenlijsten (adresboeken) en contacten beheren zoals je dat nu doet."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "We zijn onze voorwaarden en ons beleid aan het bijwerken.",
    "agreeSub": "Door Zoom te blijven gebruiken, gaat u akkoord met de bijgewerkte <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Servicevoorwaarden</a> en het <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Privacybeleid</a>.",
    "continue": "Doorgaan"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Terug naar het hoofdaccount",
      "backLinkedAccount": "Terug naar het gekoppelde account",
      "backMyAccount": "Terug naar Mijn account",
      "myAccount": "Mijn account"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion is nu beschikbaar voor je account",
      "desc": "Dit zijn enkele Custom AI Companion-functies die je in je account kunt gebruiken:",
      "studioTitle": "AI Studio",
      "studioDesc": "Pas de AI Companion-ervaring aan voor je organisatie.",
      "integrationsTitle": "Integraties van derden",
      "integrationsDesc": "Gebruik apps van derden om je workflows te stroomlijnen.",
      "clipsTitle": "Aangepaste avatars voor Zoom Clips",
      "clipsDesc": "Laat gebruikers AI-avatars personaliseren voor hun clips."
    },
    "coachMark": {
      "licenseTitle": "Je hebt {0} Custom AI Companion-licenties om toe te wijzen",
      "licenseDesc": "Wijs deze licenties toe onder <b>Gebruikersbeheer</b>, zodat je gebruikers geavanceerde AI Companion-functies kunnen gaan gebruiken.",
      "settingTitle": "Bekijk de Custom AI Companion-instellingen voor je account",
      "settingDesc": "Configureer de instellingen voor elke Custom AI-functie onder <b>Accountinstellingen</b>. <a href=\"/account/setting?tab=aicompanion\">Naar instellingen</a>",
      "groupSettingTitle": "Bekijk de Custom AI-instellingen voor je groep",
      "groupSettingDesc": "Configureer de instellingen voor elke Custom AI-functie onder <b>Groepsinstellingen</b>. <a href=\"/account/group\">Naar instellingen</a>"
    },
    "common": {
      "learnMore": "Meer informatie",
      "quickTour": "Volg een korte rondleiding",
      "remindLater": "Later herinneren",
      "dismiss": "Sluiten",
      "next": "Volgende",
      "back": "Terug",
      "gotIt": "Begrepen",
      "goToSetting": "Naar instelling"
    },
    "aiPanelToast": "Schakel de instelling <b>AI-paneel in Zoom Workplace</b> in om alle Custom AI Companion-functies te gaan gebruiken."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Begrepen",
      "next": "Volgende",
      "remindMeLater": "Later herinneren",
      "waffleMenuTitle": "Welkom bij de nieuwe Zoom-webervaring",
      "waffleMenuDesc": "Open Zoom-producten vanaf elke locatie met ons nieuwe <b>productmenu.</b>",
      "profileMenuTitle": "Mijn account",
      "profileMenuDesc": "Vind je profiel en persoonlijke instellingen in <b>Mijn account.</b>",
      "personalTitle": "Toegang tot alles wat je nodig hebt",
      "personalDesc": "<b>Mijn account</b> bevat je profiel, instellingen, vergadertranscripten en meer.",
      "adminCenterTitle": "Organisatie-instellingen vinden in het Beheercentrum",
      "adminCenterDesc": "In je nieuwe <b>Beheercentrum</b> kun je producten configureren en instellingen aanpassen voor je hele organisatie.",
      "adminMenuForTitle": "Het Beheercentrum als een pro gebruiken",
      "adminMenuForAccountSettings": "Via <b>Instellingen</b> heb je toegang tot de standaard productinstellingen voor iedereen in je organisatie.",
      "adminMenuForContentManagementItem": "Onder <b>Contentbeheer</b> beheer je alle door gebruikers gegenereerde content.",
      "adminMenuForConfigureProductsItem": "Onder <b>Productconfiguratie</b> kun je je producten instellen en admintaken uitvoeren.",
      "adminMenuForNoItems": "In het nieuwe beheercentrum kun je je accountinstellingen en producten eenvoudiger openen en beheren. Je kunt ook items vastzetten voor snellere toegang.",
      "tryNewExperience": "Nieuwe ervaring uitproberen",
      "tryNewExperienceDetail": "Probeer het uit! Je kunt altijd terugkeren naar deze klassieke ervaring.",
      "tryNewExperienceTitle": "Nieuwe look voor Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Alle rechten voorbehouden.",
    "terms": "Voorwaarden",
    "privacy": "Privacy",
    "trust_center": "Trust Center",
    "acceptable_use_guidelines": "Richtlijnen voor acceptabel gebruik",
    "legal": "Juridisch",
    "do_not_sell_my_personal_information": "Jouw privacykeuzes",
    "cookie_preferences": "Cookievoorkeuren",
    "pricing": "Abonnementen en prijzen",
    "feedback": "Feedback",
    "contact_us": "Contact"
  },
  "termChange": {
    "changeTerm": {
      "title": "Overeenkomst tot wijziging van de verlengingstermijn",
      "quoteNumbers": "Gewijzigd(e) bestelformulier(en) - {0}",
      "content1": "Door deze voorwaarden te accepteren, stemt de Klant ermee in de bestaande verlengingstermijn van het abonnement te wijzigen voor alle bestelformulieren tussen Zoom Communications, Inc. (“Zoom”) en de Klant, door de overeengekomen termijn te wijzigen van een maandelijkse verlenging naar een {0}. In ruil voor deze toezegging stemt Zoom ermee in de huidige prijzen van de Klant te handhaven gedurende de eerste nieuwe verlengingstermijn.",
      "content2": "De Klant begrijpt dat de nieuwe verlengingstermijn van {0} van toepassing is zodra de Klant hieronder op “Ik accepteer” klikt, en dat de nieuwe verlengingstermijn ingaat op de dag na het einde van de huidige maandelijkse verlengingstermijn van de Klant. Deze nieuwe verlengingstermijn geldt voor alle bestelformulieren die momenteel van kracht zijn bij Zoom, en alle toekomstige verlengingstermijnen onder deze bestelformulieren hebben dezelfde termijnlengte.",
      "content3": "De Klant erkent dat de enige wijziging de verlengingstermijn betreft en dat alle overige voorwaarden van elk bestelformulier dat momenteel van kracht is bij Zoom ongewijzigd blijven en volledig van kracht blijven overeenkomstig hun bepalingen.",
      "content4": "Je stemt er verder mee in dat dit een contractuele verplichting is tussen de Klant en Zoom.",
      "agreementText": "Door op “Ik accepteer” te klikken, bevestig je dat je bevoegd bent deze wijziging namens de Klant door te voeren en dat de Klant instemt met de hierboven beschreven voorwaarden.",
      "IDecline": "Ik weiger",
      "IAccept": "Ik accepteer"
    },
    "unableToChangeTerm": {
      "title": "Verlengingstermijn kan niet worden gewijzigd",
      "content": "Je account komt niet in aanmerking om de verlengingstermijn bij te werken. <a target=\"_blank\" href=\"{0}\">Neem contact met ons op</a> als dit een fout is.",
      "acceptedTitle": "Verlengingstermijn verlengd",
      "acceptedContent": "Je hebt de verlengingsvoorwaarden al geaccepteerd. Er is geen verdere actie nodig.",
      "GotIt": "Begrepen"
    },
    "termLengthUpdated": "Lengte van de verlengingstermijn bijgewerkt naar {0} maanden.",
    "termLengthUnchanged": "Termijnlengte ongewijzigd.",
    "errorInfo": "Er is een serverfout opgetreden. Probeer het opnieuw.",
    "x12MonthTerm": "termijn van twaalf (12) maanden",
    "x24MonthTerm": "termijn van vierentwintig (24) maanden",
    "x12MonthTermPlural": "twaalf (12) maanden",
    "x24MonthTermPlural": "vierentwintig (24) maanden"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Uw account wordt op {0} bijgewerkt naar de <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nieuwe Zoom-webervaring</a>.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Bekijk wanneer u wilt bijwerken</a>"
    },
    "completed": {
      "content": "De nieuwe Zoom-webervaring is nu actief voor alle gebruikers van uw account. Gebruikers zien de bijgewerkte interface bij hun volgende aanmelding."
    }
  }
}
